import script from "./AdminPageMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPageMain.vue?vue&type=script&setup=true&lang=js"

import "./AdminPageMain.vue?vue&type=style&index=0&id=63047a02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63047a02"]])

export default __exports__